<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!--Page Header-->
              <div class="page_header">Case Closure Review</div>
              <!--Page Header-->
              <div class="page_main">
                <el-form
                  ref="form"
                  :model="info"
                  label-position="top"
                  class="request-form"
                >
                  <el-form-item label="CAPA ID" class="full-width-item">
                    <div class="gray-input">
                      {{ info.request_id || "/" }}
                    </div>
                  </el-form-item>
                  <div class="form-grid">
                    <!-- 左侧 -->
                    <div class="form-col">
                      <el-form-item label="Status">
                        <div class="gray-input">
                          {{ info.status_name || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Priority">
                        <div class="gray-input">
                          <span v-if="info.priority == 1">High</span>
                          <span v-if="info.priority == 2">Medium</span>
                          <span v-if="info.priority == 3">Low</span>
                          <span v-if="!info.priority">/</span>
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigator">
                        <div class="gray-input">
                          {{ info.investigator || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                    <!-- 右侧 -->
                    <div class="form-col">
                      <el-form-item label="Request Date">
                        <div class="gray-input">
                          {{ info.time1 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Acceptance Date">
                        <div class="gray-input">
                          {{ info.time2 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Start Date">
                        <div class="gray-input">
                          {{ info.time3 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Completion Date">
                        <div class="gray-input">
                          {{ info.time4 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Start Date">
                        <div class="gray-input">
                          {{ info.time5 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Completion Date">
                        <div class="gray-input">
                          {{ info.time6 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Close Date">
                        <div class="gray-input">
                          {{ info.pass_time || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="text-tip">CAPA Description</div>
                  <el-form-item
                    label="Description of the Issue, Concern, Idea, or Opportunity"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.description || "/" }}
                    </div>
                  </el-form-item>
                  <div class="text-tip">Background Information</div>
                  <div class="form-grid">
                    <!-- 左侧 -->
                    <div class="form-col">
                      <el-form-item label="Requester">
                        <div class="gray-input">
                          {{ info.username || "/" }}
                        </div>
                      </el-form-item>
                      <!-- <el-form-item label="Company">
                        <div class="gray-input">
                          {{ info.company_name || "/" }}
                        </div>
                      </el-form-item> -->
                    </div>
                    <!-- 右侧 -->
                    <div class="form-col">
                      <el-form-item label="Source Type">
                        <div class="gray-input">
                          {{ info.source_type || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Department">
                        <div class="gray-input">
                          {{ info.departments_name || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <el-form-item
                    label="Source Information"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.source_info || "/" }}
                    </div>
                  </el-form-item>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">CAPA Background Files</div>
                    </div>
                    <el-table
                      :data="backdocTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop="name"
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        Articles Affected by the Issue, Concern, Idea, or
                        Opportunity
                      </div>
                    </div>
                    <el-table
                      :data="affectArticleTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop=""
                        label="Article Type"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.article_type == 1">Document</div>
                          <div v-if="scope.row.article_type == 2">
                            Equipment
                          </div>
                          <div v-if="scope.row.article_type == 3">Product</div>
                          <div v-if="scope.row.article_type == 4">Tool</div>
                          <div v-if="scope.row.article_type == 5">Other</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="article_id"
                        label="Article ID"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_name"
                        label="Article Name"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_revision"
                        label="Article Revision"
                        min-width="140"
                        sortable
                      ></el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Serial Number"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.serial_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Lot Number"
                        min-width="160"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.lot_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Purchased Product?"
                        min-width="200"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.is_buy == 1">Yes</div>
                          <div v-if="scope.row.is_buy == 2">No</div>
                          <div v-else></div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Supplier"
                        min-width="200"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.supplier_name || "" }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Correction</div>
                    </div>
                    <el-table
                      :data="correctionTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop=""
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- Investigation Activity Log -->
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Investigation Activity Log</div>
                    </div>
                    <el-table
                      :data="investigationLogTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Activity Log Entries"
                    >
                      <el-table-column
                        prop="description"
                        label="Description"
                        min-width="260"
                        sortable
                      />
                      <el-table-column
                        prop=""
                        label="Created Time"
                        min-width="120"
                        sortable
                      >
                        <template #default="scope">
                          {{ initTime(scope.row.update_time) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Last Updated"
                        min-width="140"
                        sortable
                      >
                        <template #default="scope">
                          {{ initTime(scope.row.dateline) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="attachment"
                        label="Attachment"
                        min-width="160"
                      >
                        <template #default="scope">
                          <div
                            v-for="(value, index) in scope.row.filelist"
                            :key="index"
                            style="padding: 4px 0"
                          >
                            <a :href="value.url" target="_blank">{{
                              value.name
                            }}</a>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- Solution Plan -->
                  <div class="solution-plan">
                    <!-- 标题栏 -->
                    <div class="plan-header">
                      <span class="plan-title">Solution Plan</span>
                      <el-button
                        type="text"
                        class="toggle-btn"
                        @click="toggleAll"
                      >
                        {{ allExpanded ? "Collapse" : "Expand All" }}
                        <i
                          :class="
                            allExpanded
                              ? 'el-icon-arrow-up'
                              : 'el-icon-arrow-down'
                          "
                        ></i>
                      </el-button>
                    </div>
                    <!-- 内容卡片 -->
                    <div
                      class="plan-card"
                      v-for="(item, index) in rootCause"
                      :key="index"
                    >
                      <!-- Root Cause -->
                      <section class="plan-section">
                        <div class="plan-header">
                          <span class="plan-title">Root Cause</span>
                        </div>
                        <div class="form-block">
                          <el-form-item label="Root Cause Analysis Result">
                            <div class="gray-input">
                              {{ item.analysis_results }}
                            </div>
                          </el-form-item>
                        </div>
                        <template
                          v-if="rootCauseExpanded == item.id || allExpanded"
                        >
                          <div class="form-grid">
                            <!-- 左侧 -->
                            <div class="form-col">
                              <el-form-item
                                label="Is this root cause related to a supplier?"
                              >
                                <div class="gray-input">
                                  {{ item.is_supplier == 1 ? "Yes" : "No" }}
                                </div>
                              </el-form-item>
                            </div>
                            <!-- 右侧 -->
                            <div class="form-col">
                              <el-form-item label="Root Cause Supplier">
                                <div class="gray-input">
                                  {{ item.supplier_name }}
                                </div>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="custom-panel">
                            <div class="panel-header">
                              <div class="table-title">
                                Root Cause Analysis Result Files
                              </div>
                            </div>
                            <el-table
                              :data="item.filelist"
                              border
                              stripe
                              header-cell-class-name="table-header-cell"
                              class="file-table"
                              empty-text="No Root Cause Analysis Files"
                            >
                              <el-table-column
                                prop=""
                                label="Description"
                                sortablemin-width="200"
                              >
                                <template slot-scope="scope">
                                  <div>{{ scope.row.description || "/" }}</div>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="fileName"
                                label="File Name"
                                min-width="240"
                              >
                                <template slot-scope="scope">
                                  <a :href="scope.row.url" target="_blank">{{
                                    scope.row.name
                                  }}</a>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </template>
                        <div v-if="!allExpanded" class="section-toggle">
                          <el-button
                            type="text"
                            @click="rootCauseExpandedClick(item)"
                          >
                            {{
                              rootCauseExpanded == item.id || allExpanded
                                ? "Collapse"
                                : "Expand"
                            }}
                            <i
                              :class="
                                rootCauseExpanded == item.id || allExpanded
                                  ? 'el-icon-arrow-up'
                                  : 'el-icon-arrow-down'
                              "
                            ></i>
                          </el-button>
                        </div>
                      </section>
                      <!-- 分隔线 -->
                      <div class="divider"></div>
                      <!-- Corrective Action -->
                      <div
                        class="plan-card"
                        v-for="(item2, index2) in item.caparootcauseaction_list"
                        :key="index2"
                        style="padding-left: 30px"
                      >
                        <section class="plan-section">
                          <div class="plan-header">
                            <span class="plan-title">{{
                              item2.capa_type == 1
                                ? "Corrective Action"
                                : "Preventive Action"
                            }}</span>
                          </div>
                          <div class="form-block">
                            <el-form-item label="Implementation Instructions">
                              <div class="gray-input">
                                {{ item2.implementation_instructions }}
                              </div>
                            </el-form-item>
                          </div>
                          <template
                            v-if="correctiveExpanded == item2.id || allExpanded"
                          >
                            <div class="form-block">
                              <el-form-item label="Implementer">
                                <div class="gray-input">
                                  {{ item2.implementor_username }}
                                </div>
                              </el-form-item>
                            </div>
                            <div class="form-block">
                              <el-form-item label="Planned Action Due Date">
                                <div class="gray-input">
                                  {{ initTime2(item2.end_time) }}
                                </div>
                              </el-form-item>
                            </div>
                            <div class="custom-panel">
                              <div class="panel-header">
                                <div class="table-title">Affected Files</div>
                              </div>
                              <el-table
                                :data="item2.filelist"
                                border
                                stripe
                                header-cell-class-name="table-header-cell"
                                class="file-table"
                                empty-text="No Affected Files"
                              >
                                <el-table-column
                                  prop=""
                                  label="Description"
                                  sortable
                                  min-width="200"
                                >
                                  <template slot-scope="scope">
                                    <div>
                                      {{ scope.row.description || "/" }}
                                    </div>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="fileName"
                                  label="File Name"
                                  min-width="240"
                                >
                                  <template slot-scope="scope">
                                    <a :href="scope.row.url" target="_blank">{{
                                      scope.row.name
                                    }}</a>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <div class="form-block" style="margin-top: 20px">
                              <el-form-item label="Verification Instructions">
                                <div class="gray-input">
                                  {{ item2.verification_instructions }}
                                </div>
                              </el-form-item>
                            </div>
                          </template>
                          <div v-if="!allExpanded" class="section-toggle">
                            <el-button
                              type="text"
                              @click="correctiveExpandedClick(item2)"
                            >
                              {{
                                correctiveExpanded == item2.id || allExpanded
                                  ? "Collapse"
                                  : "Expand"
                              }}
                              <i
                                :class="
                                  correctiveExpanded == item2.id || allExpanded
                                    ? 'el-icon-arrow-up'
                                    : 'el-icon-arrow-down'
                                "
                              ></i>
                            </el-button>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                  <!-- Impact of the Solution -->
                  <div class="section-block">
                    <div class="text-tip">Impact of the Solution</div>
                    <el-form-item label="Impact Documents?">
                      <div class="gray-input">
                        <span v-if="ruleForm1.impacts_documents == 1">Yes</span>
                        <span v-if="ruleForm1.impacts_documents == 2">No</span>
                      </div>
                    </el-form-item>
                    <el-form-item label="Impact Production Output?">
                      <div class="gray-input">
                        <span v-if="ruleForm1.Impacts_product == 1">Yes</span>
                        <span v-if="ruleForm1.Impacts_product == 2">No</span>
                      </div>
                    </el-form-item>
                    <el-form-item label="Production Output Impact Description">
                      <div class="gray-input">
                        {{ ruleForm1.Impacts_description || "/" }}
                      </div>
                    </el-form-item>
                    <el-form-item label="Change Authorization Requirements">
                      <div class="gray-input">
                        {{ ruleForm1.change_auth || "/" }}
                      </div>
                    </el-form-item>
                  </div>
                  <!-- CAPA Effectiveness Verification Plan -->
                  <div class="section-block">
                    <div class="text-tip">
                      CAPA Effectiveness Verification Plan
                    </div>
                    <el-form-item
                      label="Does this CAPA request require effectiveness verification?"
                    >
                      <div class="gray-input">
                        <span v-if="ruleForm2.capa_verification == 1">Yes</span>
                        <span v-if="ruleForm2.capa_verification == 2">No</span>
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="CAPA Effectiveness Verification Instructions"
                    >
                      <div class="gray-input">
                        {{ ruleForm2.capa_instructions }}
                      </div>
                    </el-form-item>
                    <el-form-item label="Verification Plan Assignee">
                      <div class="gray-input">
                        {{ ruleForm2.capa_instructions_username }}
                      </div>
                    </el-form-item>
                    <el-form-item label="Verification Plan Due Date">
                      <div class="gray-input">
                        {{ ruleForm2.capa_instructions_endtime }}
                      </div>
                    </el-form-item>
                    <el-form-item label="Reason Verification Is Not Required">
                      <div class="gray-input">
                        {{ ruleForm2.nocapa_reason }}
                      </div>
                    </el-form-item>
                  </div>
                  <!-- 启动CAPA 有效性验证后显示 -->
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        CAPA Effectiveness Verification Files
                      </div>
                    </div>
                    <el-table
                      :data="validationTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop=""
                        label="Description"
                        sortable
                        min-width="200"
                      >
                        <template slot-scope="scope">
                          <div>{{ scope.row.description || "/" }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="fileName"
                        label="File Name"
                        min-width="240"
                      >
                        <template slot-scope="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="custom-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        CAPA Verification Task History
                      </div>
                    </div>
                    <el-table
                      :data="validaHistoryList"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop="task"
                        label="Additional Notes"
                        sortable
                      />
                      <el-table-column
                        prop="status"
                        label="Task Status/Result"
                        sortable
                      >
                        <template slot-scope="scope">
                          <div v-if="scope.row.status == 1">In Progress</div>
                          <div v-if="scope.row.status == 2">Approved</div>
                          <div v-if="scope.row.status == 3">Rejected</div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="remark" label="Comment" sortable />
                      <el-table-column
                        prop="apply_username"
                        label="Task Owner"
                        sortable
                      />
                      <el-table-column
                        prop="end_time"
                        label="Task Due Date"
                        sortable
                      />
                    </el-table>
                  </div>
                  <!-- 启动CAPA 有效性验证后显示 -->
                  <!-- Bottom Buttons -->
                  <div class="footer-btn">
                    <el-button type="primary" size="small" @click="handleLater">
                      Complete Later
                    </el-button>
                    <el-button
                      type="primary"
                      size="small"
                      @click="handleReturn"
                    >
                      Return to Implementation
                    </el-button>
                    <el-button type="primary" size="small" @click="handleStar">
                      Start CAPA Effectiveness Verification
                    </el-button>
                    <el-button type="primary" size="small" @click="handleClose">
                      Close Request
                    </el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!--Signature Dialog-->
    <el-dialog
      title="Case Closure Review Signature"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit">Comment</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm('ruleForm')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Signature Dialog-->
    <!--Return to Implementation弹框-->
    <el-dialog
      title="Return to Implementation"
      :visible.sync="dialogVisible1"
      width="50%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>
          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Task Execution Instructions</div>
              <el-form-item label="" prop="shuoming">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm1.shuoming"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Task Owner</div>
              <el-form-item label="" prop="account">
                <el-select
                  filterable
                  v-model="ruleForm1.account"
                  placeholder="Please select"
                  class="full-width"
                  clearable
                >
                  <el-option
                    v-for="value in userList"
                    :key="value.id"
                    :label="value.username"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Task Due Date</div>
              <el-form-item label="" prop="task_end_time">
                <el-date-picker
                  v-model="ruleForm1.task_end_time"
                  type="date"
                  placeholder="Please select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit">Comment</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm1.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm1.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible1 = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm1('ruleForm1')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Return to Implementation弹框-->
    <!--Start CAPA Effectiveness Verification弹框-->
    <el-dialog
      title="Start CAPA Effectiveness Verification"
      :visible.sync="dialogVisible2"
      width="50%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>
          <el-form
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleForm2"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">CAPA Verification Assignee</div>
              <el-form-item label="" prop="account">
                <el-select
                  filterable
                  v-model="ruleForm2.account"
                  placeholder="Please select"
                  class="full-width"
                  clearable
                >
                  <el-option
                    v-for="value in userList"
                    :key="value.id"
                    :label="value.username"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">CAPA Verification Due Date</div>
              <el-form-item label="" prop="response_end_time">
                <el-date-picker
                  v-model="ruleForm2.response_end_time"
                  type="date"
                  placeholder="Please select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit">Additional Notes</div>
              <el-form-item label="" prop="shuoming">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm2.shuoming"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit">Comment</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm2.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm2.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible2 = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm2('ruleForm2')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Start CAPA Effectiveness Verification弹框-->
  </div>
</template>

<script>
import { resourcesApplyDetail } from "@/api/docManage/changeRequest/index";
import { ApplyHandle } from "@/api/capaManage/capaRequest/index";
import { usersList } from "@/api/system/user";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from "js-md5";
import moment from "moment";
export default {
  name: "CapaDetail",
  components: {
    headers,
    slider,
  },
  data() {
    return {
      showSolution: true,
      rootCauseExpanded: null,
      correctiveExpanded: null,
      allExpanded: false,
      info: {},
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      userList: [],
      dialogTitle: "New Signature Request",
      backdocTableData: [],
      affectArticleTableData: [],
      correctionTableData: [],
      investigationLogTableData: [],
      rootCauseFiles: [],
      affectedFiles: [],
      verifyFiles: [],
      validationTableData: [],
      validaHistoryList: [],
      taskList: [],
      historyTableData: [],
      rootCause: [],
      ruleForm: {
        remark: "",
        signature: "",
      },
      rules: {
        remark: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogTitle == "Reject Signature Request" && !value) {
                callback(new Error("Comment is required when rejecting"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      ruleForm1: {
        shuoming: "",
        account: "",
        task_end_time: "",
        remark: "",
        signature: "",
      },
      rules1: {
        shuoming: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
        account: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        task_end_time: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      ruleForm2: {
        account: "",
        response_end_time: "",
        shuoming: "",
        remark: "",
        signature: "",
      },
      rules2: {
        account: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        response_end_time: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      step: null,
    };
  },
  computed: {
    //
  },
  mounted() {
    let that = this;
    that.step = that.$route.query.step;
    //请求用户列表
    usersList({ page: 1, page_size: 9999, status: 1 }).then((res) => {
      that.userList = res.data.data;
    });
    //请求页面详情
    resourcesApplyDetail({ id: that.$route.query.oid }).then((res) => {
      if (res.code == 200) {
        // console.log(res.data);
        that.info = {
          ...that.info,
          id: res.data.id,
          request_id: res.data.request_id,
          status_name: res.data.status_name,
          priority: res.data.priority,
          investigator: res.data.investigator,
          description: res.data.description,
          username: res.data.username,
          // company_name: res.data.company_name,
          source_type: res.data.source_type,
          departments_name: res.data.departments_name,
          source_info: res.data.source_info,
          time1: res.data.time1,
          time2: res.data.time2,
          time3: res.data.time3,
          time4: res.data.time4,
          time5: res.data.time5,
          time6: res.data.time6,
          pass_time: res.data.pass_time,
          step_name: res.data.step_name,
          verfity_num: res.data.verfity_num,
        };
        // 回显CAPA背景文件
        that.backdocTableData = res.data.capabackground_list || [];
        // 回显更正文件
        that.correctionTableData = res.data.capacorrections_list || [];
        // 回显受影响的文章
        that.affectArticleTableData = res.data.capaarticle_list || [];
        // 活动日志
        that.investigationLogTableData = res.data.capaaffected_list || [];
        // 根本原因
        that.rootCause = res.data.caparootcause_list || [];
        // 解决方案的影响
        that.ruleForm1.impacts_documents = res.data.impacts_documents
          ? res.data.impacts_documents
          : "";
        that.ruleForm1.Impacts_product = res.data.Impacts_product
          ? res.data.Impacts_product
          : "";
        that.ruleForm1.Impacts_description = res.data.Impacts_description;
        that.ruleForm1.change_auth = res.data.change_auth;
        // CAPA有效性验证计划
        that.ruleForm2.capa_verification = res.data.capa_verification
          ? res.data.capa_verification
          : "";
        that.ruleForm2.capa_instructions = res.data.capa_instructions;
        that.ruleForm2.capa_instructions_endtime = res.data
          .capa_instructions_endtime
          ? that.initTime2(res.data.capa_instructions_endtime)
          : "";
        that.ruleForm2.capa_instructions_username =
          res.data.capa_instructions_username;
        that.ruleForm2.nocapa_reason = res.data.nocapa_reason;
        that.$nextTick(() => {
          that.ruleForm2.capa_instructions_uid = res.data.capa_instructions_uid
            ? res.data.capa_instructions_uid
            : "";
        });
        // CAPA有效性验证文件
        that.validationTableData = res.data.capa_verification_results_list;
        // CAPA有效性验证任务历史
        that.validaHistoryList = res.data.capa_verification_apply_list;
        //审批记录
        // that.historyTableData = res.data.apply_list;
      }
    });
  },
  methods: {
    //初始化时间
    initTime(value) {
      if (value) {
        return moment(value * 1000).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "/";
      }
    },
    //初始化时间
    initTime2(value) {
      if (value) {
        return moment(value * 1000).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },
    // 关闭请求
    handleClose() {
      let that = this;
      if (that.info.verfity_num > 0) {
        that.dialogVisible = true;
      } else {
        that.$message.warning("Please start CAPA Effectiveness Verification first");
      }
    },
    // 启动CAPA有效性验证
    handleStar() {
      let that = this;
      if (that.ruleForm2.capa_verification == 1) {
        that.dialogVisible2 = true;
      } else {
        that.$message.warning("CAPA Effectiveness Verification is not required for this workflow");
      }
    },
    // 稍后完成
    handleLater() {
      let that = this;
      that.$router.back();
    },
    // 返回实施
    handleReturn() {
      let that = this;
      that.dialogVisible1 = true;
    },
    // 关闭请求确定
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        that.$toast.loading({ duration: 0, forbidClick: true });
        ApplyHandle({
          id: that.$route.query.oid,
          status: 2,
          remark: that.ruleForm.remark,
          signature: md5(that.ruleForm.signature + "AiisoQms2026"),
        }).then((res2) => {
          if (res2.code == 200) {
            that.$toast.clear();
            that.$message.success("Operation Successful");
            setTimeout(() => {
              that.$router.push({ path: "/task-list" });
            }, 800);
          }
        });
      });
    },
    //返回实施确定
    submitForm1(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        that.$toast.loading({ duration: 0, forbidClick: true });
        ApplyHandle({
          id: that.$route.query.oid,
          status: 3,
          task: that.ruleForm1.shuoming,
          apply_uid: that.ruleForm1.account,
          end_time: moment(that.ruleForm1.task_end_time).valueOf() / 1000,
          remark: that.ruleForm1.remark,
          signature: md5(that.ruleForm1.signature + "AiisoQms2026"),
        }).then((res) => {
          if (res.code == 200) {
            that.$toast.clear();
            that.$message.success("Operation Successful");
            setTimeout(() => {
              that.$router.push({ path: "/task-list" });
            }, 800);
          }
        });
      });
    },
    // 启动CAPA有效性验证确定
    submitForm2(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        ApplyHandle({
          id: that.$route.query.oid,
          status: 2,
          uid: that.ruleForm2.account,
          end_time: moment(that.ruleForm2.response_end_time).valueOf() / 1000,
          capa_add_instructions: that.ruleForm2.shuoming,
          remark: that.ruleForm2.remark,
          signature: md5(that.ruleForm2.signature + "AiisoQms2026"),
        }).then((res2) => {
          if (res2.code == 200) {
            that.$toast.clear();
            that.$message.success("Operation Successful");
            setTimeout(() => {
              that.$router.push({ path: "/task-list" });
            }, 800);
          }
        });
      });
    },
    //展开 & 隐藏全部
    toggleAll() {
      let that = this;
      that.allExpanded = !that.allExpanded;
      if (!that.allExpanded) {
        that.rootCauseExpanded = null;
        that.correctiveExpanded = null;
      }
    },
    //展开 & 隐藏
    rootCauseExpandedClick(value) {
      let that = this;
      if (that.rootCauseExpanded == value.id) {
        that.rootCauseExpanded = null;
      } else {
        that.rootCauseExpanded = value.id;
      }
    },
    correctiveExpandedClick(value) {
      let that = this;
      if (that.correctiveExpanded == value.id) {
        that.correctiveExpanded = null;
      } else {
        that.correctiveExpanded = value.id;
      }
    },
    viewTask(row) {
      console.log("View Task:", row);
    },
  },
};
</script>


<style lang="less" scoped>
.save_box {
  .btn_box {
    text-align: right;

    .btn_el {
      margin-left: 10px;
      padding: 12px 24px;

      .van-button__text {
        font-size: 16px;
      }
    }
  }

  .form_box {
    .input_el {
      .tit {
        padding-bottom: 5px;
        font-size: 14px;
        color: #333333;
      }

      .required::before {
        content: "*";
        color: red;
        margin-right: 2px;
      }

      .full-width {
        width: 100%;
      }
    }
  }
}

//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;

    .btn_el {
      margin: 10px 0 20px 0;

      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>

<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* 输入框统一风格 */
.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.text-tip {
  background-color: #fafafa;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.file-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 40px;
}

.custom-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.search-input {
  width: 220px;
}

.file-table {
  width: 100%;
  margin-top: 8px;
}

.solution-plan {
  width: 100%;
  color: #303133;
  font-size: 13px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.plan-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.plan-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  margin-right: 8px;
}

.toggle-btn {
  padding: 0;
  font-size: 13px;
}

.plan-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}

.plan-section {
  padding: 28px 20px 18px;
}

.section-title {
  margin: 0 0 26px;
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.sub-title {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 20px;
}

.form-block {
  margin-bottom: 10px;
}

.field-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #303133;
}

.section-toggle {
  margin-top: 12px;
}

.section-toggle .el-button {
  padding: 0;
  font-size: 14px;
  font-weight: 600;
}

.divider {
  height: 1px;
  background: #ebeef5;
}

.custom-table {
  margin-bottom: 14px;
  width: 100%;
}

.el-icon-arrow-down,
.el-icon-arrow-up {
  margin-left: 2px;
}

.footer-actions {
  display: flex;
  margin-top: 50px;
  flex-direction: column;
  align-self: center;
}

.footer-btn {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-self: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-group {
  margin-top: 16px;
}

.action-task-panel {
  margin-top: 20px;
}
</style>